
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`We've addded support for visualizations using Mapbox and Highcharts. We also have new design patterns and code examples for Registration and App Bars, as well as a bunch of new icon packages.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;